import React, { useState } from 'react';

interface DraggableItem {
  id: number;
  content: string;
}

interface DragAndDropProps {
  items: any[];
  onDrop: (items: DraggableItem[]) => void;
}

const Dragable: React.FC<DragAndDropProps> = ({ items, onDrop }) => {
  const [draggedItem, setDraggedItem] = useState<DraggableItem | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);

  const handleDragStart = (item: DraggableItem) => {
    setDraggedItem(item);
  };

  const handleDragOver = (index: number, e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault(); 
    setDragOverIndex(index);
  };

  const handleDrop = () => {
    if (draggedItem && dragOverIndex !== null) {
      const updatedItems = [...items];
      const draggedIndex = items.findIndex((i) => i.id === draggedItem.id);
      updatedItems.splice(draggedIndex, 1); 
      updatedItems.splice(dragOverIndex, 0, draggedItem); 

      onDrop(updatedItems); 
    }

    setDraggedItem(null);
    setDragOverIndex(null);
  };

  return (
    <div>
      {items.map((item, index) => (
        <div
          key={item.id}
          draggable
          onDragStart={() => handleDragStart(item)}
          onDragOver={(e) => handleDragOver(index, e)}
          onDrop={handleDrop}
          style={{
            padding: '10px',
            margin: '10px 0',
            backgroundColor: dragOverIndex === index ? '#f0f0f0' : '#fff',
            border: '1px solid #ddd',
            cursor: 'move',
          }}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Dragable;